import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonList, IonItem, 
  IonLabel,
  IonItemSliding,
  IonItemOption,
  IonItemOptions,
  IonFab,
  IonFabButton,
  IonIcon,
  IonAlert,
  IonLoading,
  IonFabList,
  useIonRouter
  } from '@ionic/react';
  import React, {useState, useEffect, useRef} from 'react';
  import './Accounts.css';
  import ServerService from '../../../services/Server';
  import { add, enter, exit, playOutline, serverOutline } from 'ionicons/icons';
  import { useHistory } from 'react-router-dom';
  import { setAuthPersisted, clearAuthPersisted } from '../../../services/pinUtils';
  import { useAuth } from '../../../context/AuthContext';
  
  const Accounts: React.FC = () => {
    
    const name:string = "Accounts";

    const history = useHistory();
    const router = useIonRouter();
    const { login, logout, isAuthenticated } = useAuth();
    
    const server = new ServerService();
    server.setHistory(history);
   
    const [msg, setMsg] = useState("Login Successful");
    const [showMsg, setShowMsg] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [accounts, setAccounts] = useState(server.accounts)
    const listRef = useRef(null)

    const fileInput = useRef(null);
    
    const alertCallback = () => {
        window.location.reload();
    }

    const loginCallback = (result:boolean, msg:string) => {
      setShowLoading(false)
      if (msg) {
        server.clearTicket()
        server.saveLocal();
        setMsg(msg)
        setShowMsg(true)
      } else {
        //console.log("loginCallback success")
        setAccounts(server.accounts);
        console.log("server.state.pin: "+server.state.pin);
        if (server.state.pin != "1") {
          if (!isAuthenticated) {
            login();
          }
          //const now = new Date();
          //const dmy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();
          setAuthPersisted();
          //window.location.href = "/page/home/mytasks?dmy="+dmy
          window.location.href = "/page/home"
        } else {
          if (isAuthenticated) {
            logout();
          }
          //clearAuthPersisted();
          window.location.href = "/page/pin";
        }
      }
    }

   const setActiveAccount = (key:any) => {
      setShowLoading(true);
      server.activeAcc=key;
      server.saveLocal();

      server.login(loginCallback);
   }

   const removeAccount = (key:any) => {
      server.accounts.splice(key, 1);
      if (key < server.activeAcc) {
        server.activeAcc--;
      }
      server.saveLocal();
      window.location.reload();
   }

   const importAccount = (file:any) => {

      const fileReader = new FileReader();
      fileReader.readAsText(file, "UTF-8");
      fileReader.onload = e => {
        const content = JSON.parse(e.target.result.toString())
        server.accounts.push(...content)
        setAccounts(server.accounts)
        server.saveLocal();
        window.location.reload();
      }
   }

   const exportAccount = () => {
      const fileData = JSON.stringify(server.accounts);
      const blob = new Blob([fileData], {type: "text/plain"});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = 'accts.dat';
      link.href = url;
      link.click();
      link.remove();
   }

   useEffect(() => {
      
   }, accounts)

  return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
  
        <IonContent>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle>{name}</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonList ref={listRef}>

            {accounts.map((account, key) => {
              return (
                <IonItemSliding key={key}>
                  
                  <IonItemOptions key={key} side="start">
                    <IonItemOption onClick={(e) => {
                      e.preventDefault()
                      listRef.current.closeSlidingItems()
                      history.push("/page/settings/accounts/account/"+key)
                    }}>Edit</IonItemOption>
                  </IonItemOptions>

                  <IonItem onClick={() => {setActiveAccount(key)}}>
                    <IonIcon icon={serverOutline} color={server.activeAcc===key ? "primary" : undefined}/>
                    <IonLabel color={server.activeAcc===key ? "primary" : undefined}>
                      &nbsp;&nbsp;{account.name}
                    </IonLabel>
                  </IonItem>

                  {server.activeAcc!==key ?
                  <IonItemOptions side="end">
                    <IonItemOption color="danger" onClick={(e) => removeAccount(key)}>Remove</IonItemOption>
                  </IonItemOptions>
                  : ""}
                </IonItemSliding>
            )
            })}
          </IonList>
          <input
            ref={fileInput}
            hidden
            type="file"
            accept=".dat,.txt"
            onChange={e => {
              console.log("onChange");
              importAccount(e.target.files[0]);
            }}
            onClick={(e) => {
              console.log('onClick');
              e.stopPropagation()
            }}
          />
          
          <IonFab slot="fixed" vertical="bottom" horizontal={server.state.handed==="right" ? "end" : "start"}>
            <IonFabButton color="light">
              <IonIcon icon={playOutline}></IonIcon>
            </IonFabButton>
            <IonFabList side="top">
              <IonFabButton color="primary" routerLink={"/page/settings/accounts/account/-"}><IonIcon size="large" icon={add}></IonIcon></IonFabButton>
            </IonFabList>
            <IonFabList side="start">
              <IonFabButton color="success" onClick={() => {
                  console.log("import")
                  fileInput?.current?.click();
                }}><IonIcon size="large" icon={enter}></IonIcon>
              </IonFabButton>
              <IonFabButton color="success" onClick={() => {
                  console.log("export")
                  exportAccount()
                }}><IonIcon size="large" icon={exit}></IonIcon>
              </IonFabButton>
            </IonFabList>
          </IonFab>

  <IonAlert
    isOpen={showMsg}
    onDidDismiss={alertCallback}
    message={msg}
    buttons={['OK']}
  />
  <IonLoading 
    isOpen={showLoading}
    message="Please wait..."
  />
        </IonContent>
      </IonPage>
    );
  };
  
  export default Accounts;
  